export class BackupError extends Error {

}

export class BackupVersionError extends BackupError {
  constructor(backupVersion, supportedVersion, ...params) {
    super(...params);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BackupVersionError);
    }

    this.name = 'BackupVersionError';
    this.backupVersion = backupVersion;
    this.supportedVersion = supportedVersion;
    this.message = `Backup version '${backupVersion}' not supported, `
      + `maximum supported backup version is '${supportedVersion}'.`;
  }
}
